import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const team = [
  { name: 'Priya Patel', role: 'CEO', img: '', bio: 'Visionary leader with 10+ years in digital marketing.' },
  { name: 'Rahul Mehra', role: 'Lead Developer', img: '', bio: 'Expert in web and mobile solutions.' },
  { name: 'Sara Lee', role: 'Content Strategist', img: '', bio: 'Storyteller and SEO specialist.' },
];

const Team = () => (
  <section className="min-h-screen bg-[#0f1a29] py-20 px-4 flex flex-col items-center justify-center">
    <div className="max-w-4xl w-full bg-white rounded-2xl shadow-2xl p-10 relative z-10">
      <motion.h1
        className="text-4xl font-bold text-brand-blue mb-6 text-center"
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: 'easeOut' }}
      >
        Meet the Team
      </motion.h1>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {team.map((m, i) => (
          <motion.div
            key={i}
            className="bg-blue-50 rounded-lg p-6 shadow flex flex-col items-center"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: i * 0.2, ease: 'easeOut' }}
          >
            <div className="w-24 h-24 bg-blue-200 rounded-full mb-4 flex items-center justify-center text-2xl font-bold text-brand-blue">
              {m.img ? <img src={m.img} alt={m.name} className="w-full h-full rounded-full object-cover" /> : m.name[0]}
            </div>
            <h2 className="text-xl font-bold text-brand-blue mb-1">{m.name}</h2>
            <p className="text-gray-700 mb-2">{m.role}</p>
            <p className="text-gray-500 text-sm text-center">{m.bio}</p>
          </motion.div>
        ))}
      </div>
      <div className="flex flex-col sm:flex-row gap-4 justify-center mt-8">
        <Link to="/" className="px-6 py-3 bg-brand-blue text-white rounded-lg shadow hover:bg-blue-700 transition font-semibold text-center">Back to Home</Link>
        <Link to="#contact" onClick={e => { e.preventDefault(); const section = document.getElementById('contact'); if (section) section.scrollIntoView({ behavior: 'smooth' }); }} className="px-6 py-3 bg-blue-100 text-brand-blue rounded-lg shadow hover:bg-blue-200 transition font-semibold text-center">Contact Us</Link>
      </div>
    </div>
  </section>
);

export default Team; 